import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabDirective } from 'ngx-bootstrap/tabs';
import { AppSyncWebSocketService } from 'src/app/appsyncwebsocketservice.service';
import { featureIconMap } from 'src/app/constants/app-constants';
import { AutoUnsubscribeService } from 'src/app/services/auto-unsubscribe.service';
import { MainService } from 'src/app/services/main.service';

@Component({
    selector: 'app-scene-profile',
    templateUrl: './scene-profile.component.html',
    styleUrls: ['./scene-profile.component.css'],
    standalone: false
})
export class SceneProfileComponent extends AutoUnsubscribeService implements OnInit, OnDestroy {

  sceneId: any;
  siteId: any ;
  sceneDetailsLoadComplete: boolean = false;
  sceneDetailsResponse: any;
  value: any;
  sceneCurrentStatus: any;
  asyncEvent: { [key: string]: any[] } = {};
  sceneExecutionState: any;
  lastSceneUpdateReceived:any;

  constructor(public mainService: MainService, public activatedRoute: ActivatedRoute, private appSyncWebSocketService: AppSyncWebSocketService) {
    super();
    this.setComponentName(this.constructor.name);
  }

  ngOnInit(): void {
    this.sceneId = this.activatedRoute.snapshot.paramMap.get('sceneId');
    this.siteId = this.activatedRoute.snapshot.paramMap.get('siteId');
    this.getSceneDetails();
  }

  onSelect(data: TabDirective): void {
    this.value = data.heading();
    this.sceneId = this.activatedRoute.snapshot.paramMap.get('sceneId');
  }

  getSceneDetails() {
    this.mainService.getSceneDetails(this.sceneId, this.siteId).subscribe((data: any) => {
      if (data) {
        // this.updateFeatureIconSrc(data.status.mode); // Update icon when iconId is available
        this.sceneDetailsLoadComplete = true;
        this.sceneDetailsResponse = data;
        this.sceneCurrentStatus = data.sceneStatus;
        this.websocketConnection();
      }
    });

  }

  getSceneIconSrc(): string {
    return `assets/img/${this.sceneDetailsResponse.sceneIconId}.svg`;
  }

  websocketConnection() {
    this.appSyncWebSocketService.connectWebSocket(this.sceneDetailsResponse.controllerSerial);
    this.appSyncWebSocketService.getStatusEvent().subscribe(data => {
      if (data) {
        const flattenedPayload = { ...(typeof data.payload === 'object' ? data.payload : {}), context: data.context, dataModelVersion: data.dataModelVersion, ventType: data.eventType };

        if (!this.asyncEvent![data.context]) {
          this.asyncEvent[data.context] = [];
        }

        this.asyncEvent[data.context].push(flattenedPayload);

        const realTimeForScenes = this.asyncEvent?.['scenes'];
        this.mainService.updateRealTimeDataForScenes.next(realTimeForScenes);

        this.lastSceneUpdateReceived = Array.isArray(realTimeForScenes)
          ? [...realTimeForScenes]
              .reverse()
              .find(item =>
                this.sceneId === item.sceneId
              )
          : null;

          // Update the scene execution state and icon based on the real-time update
        if (this.lastSceneUpdateReceived) {
          this.sceneExecutionState = this.lastSceneUpdateReceived?.status?.executionState;
          this.sceneDetailsResponse.sceneIconId = this.lastSceneUpdateReceived?.iconId || this.sceneDetailsResponse.sceneIconId; // Update iconId if available in the real-time update
          this.sceneDetailsResponse.activationReason = this.lastSceneUpdateReceived?.status?.triggerType || this.sceneDetailsResponse.activationReason; // Update activation reason if available
          this.sceneDetailsResponse.sceneName = this.lastSceneUpdateReceived?.displayName || this.sceneDetailsResponse.sceneName; // Update scene name if available
        }
      }
    });
  }


  navigateBack(): void {
    this.mainService.goBack();
  }

  getSceneState(): string {
    if (this.sceneExecutionState) {
      return this.sceneExecutionState?.toLowerCase() === "stopped" ? 'Off' : 'On';
    }
    return this.sceneCurrentStatus || "";
  }

  getSceneActivationReason(): string {
    const reason = this.sceneDetailsResponse?.activationReason?.toLowerCase();
    switch (reason) {
      case 'manual':
        return 'Manual';
      case 'scheduled':
        return 'Schedule';
      case 'freezeprotect':
        return 'Freeze Protect';
      default:
        return "-";
    }
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy?.();
  }
}
